import React from 'react'
import { Checkbox, FormControlLabel, FormHelperText, MenuItem } from '@mui/material'
import { CustomInput } from '../../../components/custom-input/CustomInput'

interface LocationSelectorProps {
  location: any
  setLocation: (value: any) => void
  takeaway: boolean
  setTakeaway: (value: boolean) => void
  locations: any[]
  errorState: { location: boolean }
  t: (key: string) => string
  setPosition: (pos: L.LatLng | null) => void
  setCoordinates: (coords: Partial<L.LatLng>) => void
  getTranslatedName: (item: any) => string
}

const LocationSelector: React.FC<LocationSelectorProps> = ({
  location,
  setLocation,
  takeaway,
  setTakeaway,
  locations,
  errorState,
  t,
  setPosition,
  setCoordinates,
  getTranslatedName,
}) => (
  <div className="checkout-page__container-location">
    <div className="checkout-page__container-location-input">
      <CustomInput
        select
        fullWidth
        error={!takeaway && !errorState.location}
        value={location || ''}
        label={t('LOCATION')}
        placeholder="location"
        backgroundColor="#F0F0F0"
        variant="filled"
        onChange={(e) => {
          setLocation(e.target.value)
          setTakeaway(false)
        }}
      >
        {locations.map((loc, index) => (
          <MenuItem key={index} value={loc}>
            {getTranslatedName(loc)}
          </MenuItem>
        ))}
      </CustomInput>
      {!takeaway && !errorState.location && (
        <FormHelperText error id="component-error-text">
          {t('FIELD_REQUIRED')}
        </FormHelperText>
      )}
    </div>
    <div className="checkout-page__container-location-input">
      <FormControlLabel
        label={t('PICKUP')}
        control={
          <Checkbox
            size="small"
            checked={takeaway}
            onChange={(e) => {
              setTakeaway(e.target.checked)

              if (e.target.checked) {
                setLocation(null)
                setPosition({ lat: 48.331216, lng: 26.87127 } as L.LatLng)
                setCoordinates({ lat: 48.331216, lng: 26.87127 })
              } else {
                setPosition(null)
              }
            }}
            style={{ color: '#ff1647' }}
          />
        }
      />
      <a
        className="checkout-page__container-location-input-map"
        onClick={(e) => {
          e.preventDefault()
          setPosition({ lat: 48.331216, lng: 26.87127 } as L.LatLng)
          setCoordinates({ lat: 48.331216, lng: 26.87127 })
        }}
      >
        {t('LOCATION_MAP')}
      </a>
    </div>
  </div>
)

export default LocationSelector